import { Badge } from '@/components/ui/badge';

export function LabelBadges({ labels, emptyText }: { labels: string[] | undefined; emptyText: string }) {
  if (!labels || labels.length === 0) {
    return <span className="text-muted-foreground text-sm">{emptyText}</span>;
  }

  return (
    <div className="flex flex-wrap gap-1">
      {labels.map((label) => (
        <Badge key={label} variant="secondary" className="font-mono">
          {label}
        </Badge>
      ))}
    </div>
  );
}
